import {FC, useContext, useEffect, useRef, useState} from "react";
import Heading from "../components/ui/Heading";
import Card from "../components/ui/Card";
import ListNav from "../components/ListNav";
import ListNavItem from "../components/ListNavItem";
import {Outlet} from "react-router-dom";
import {AdminContext} from "../context/AdminContext";
import useApi from "../hooks/useApi";
import Loading from "../components/Loading";

const Admin: FC = () => {
    const mounted = useRef(false);
    const {fetchFlows, fetchFlowExecutionPolicies} = useApi();
    const admCtx = useContext(AdminContext);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        mounted.current = true;
        return () => {mounted.current=false}
    })

    useEffect(() => {
        setLoading(true);
        Promise.all([fetchFlows(),fetchFlowExecutionPolicies()]).then((res) => {
            if(!mounted.current) return;
            setLoading(false);
            if (res[0]) admCtx.dispatch({type: 'SET_FLOWS', payload: res[0].flows});
            if (res[1]) admCtx.dispatch({type: 'SET_POLICIES', payload: res[1]});
        })
    }, [fetchFlows, fetchFlowExecutionPolicies])

    return (
        <section>
            {!loading ? (
                <>
                    <Heading>Administration</Heading>
                    <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-6 lg:gap-x-4">
                        <div className="flex flex-col space-y-4">
                            <Card>
                                <ListNav>
                                    <ListNavItem to='/admin/flows'>Flows</ListNavItem>
                                    <ListNavItem to='/admin/flow_policies'>Flow Policies</ListNavItem>
                                    <ListNavItem to='/admin/units'>Bereiche</ListNavItem>
                                    <ListNavItem to='/admin/logs'>Logs</ListNavItem>
                                    <ListNavItem to='/admin/actions'>Actions</ListNavItem>
                                    <ListNavItem to='/admin/settings'>Einstellungen</ListNavItem>
                                </ListNav>
                            </Card>
                        </div>
                        <div className="flex flex-col space-y-4 col-span-5">
                            <Outlet/>
                        </div>
                    </div>
                </>
            ) : <Loading/>}
        </section>
    );
};

export default Admin;